export const EVENT_HIDE_GAME_SEARCH_MODAL = "EVENT_HIDE_GAME_SEARCH_MODAL";
export const EVENT_SHOW_GAME_SEARCH_MODAL = "EVENT_SHOW_GAME_SEARCH_MODAL";
